
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface NotFoundViewProps {
  title?: string;
  message?: string;
  linkText?: string;
  linkTo?: string;
}

const NotFoundView: React.FC<NotFoundViewProps> = ({
  title = "Not Found",
  message = "The item you're looking for doesn't exist or has been removed.",
  linkText = "Back",
  linkTo = "/"
}) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">{title}</h1>
          <p className="text-muted-foreground mb-6">{message}</p>
          <Button asChild>
            <Link to={linkTo}>{linkText}</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundView;
